export default "__VITE_ASSET__D1vBbcTe__"